import ModelUtil from '@leverege/model-util';
import { Attributes, DetailModel, AttributeDetailModel, Formatters } from '@leverege/ui-attributes';

/* Initialize Constants */
const VALUE_TYPE = 'image';
const TYPE = `attr.detail.${VALUE_TYPE}`;

/**
 * Gets name from data.
 */
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

/* Initialize Model Base */
const base = {
  ...AttributeDetailModel,
  getName,
  ...ModelUtil.createAllValue('formatter')
};
delete base.create;
delete base.TYPE;
const dModel = {
  formatter: Formatters.createFormatterModel(VALUE_TYPE),
  objectFit: 'contain',
  imageWidth: 100,
  imageHeight: 100,
  percentage: false,
  value: {
    showIfEmpty: true,
    emptyIcon: 'fak fa-lv-single-image'
  },
  dialog: {
    objectFit: 'contain',
    imageWidth: 718,
    imageHeight: 525,
    titleIcon: 'https://storage.googleapis.com/molten-ui-assets/screen-icons/screen-image-blue.svg'
  }
};

/**
 * Creates an attribute detail model instance.
 */
function create(attrName, objectType) {
  const mdl = DetailModel.create(TYPE, {
    attrName,
    objectType,
    ...structuredClone(dModel)
  });
  mdl.label.align = 'top';
  return mdl;
}

/* Export Modules */
export default {
  TYPE,
  ...ModelUtil.createAllValue('value/emptyIcon', 'emptyIcon'),
  ...ModelUtil.createAllValue('objectFit', 'objectFit'),
  ...ModelUtil.createAllValue('imageWidth', 'imageWidth'),
  ...ModelUtil.createAllValue('percentageWidth', 'percentageWidth'),
  ...ModelUtil.createAllValue('imageHeight', 'imageHeight'),
  ...ModelUtil.createAllValue('imageBackgroundColor', 'imageBackgroundColor'),
  ...ModelUtil.createAllValue('showCount', 'showCount'),
  ...ModelUtil.createAllValue('percentageHeight', 'percentageHeight'),
  ...ModelUtil.createAllValue('imagePaneVariant', 'imagePaneVariant'),
  ...ModelUtil.createAllValue('dialog/objectFit', 'dialogObjectFit'),
  ...ModelUtil.createAllValue('dialog/imageWidth', 'dialogImageWidth'),
  ...ModelUtil.createAllValue('dialog/imageHeight', 'dialogImageHeight'),
  ...ModelUtil.createAllValue('dialog/titleIcon', 'dialogTitleIcon'),
  dModel,
  create,
  ...base
};